import { useEffect, useState } from "react";
import { getAPI } from "services/CRUDServices";

const useGetQuestionLists = ( questionBankOpen, currentData) => {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchQuestions = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAPI(
        `/customer-api/question/v1/s0/questionList`
      );
      const data = response?.data?.response;
      setQuestions(data);
    } catch (err: any) {
      setError(err.message || "Failed to fetch questions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, [questionBankOpen]);

  return { questions, setQuestions, loading, error, refetch: fetchQuestions };
};

export default useGetQuestionLists;
